<div class="position-relative">
  <img *ngIf="!showLineDetails && currentUrl !== '/home'" (click)="showLine()" class="d-md-none float-end position-absolute smaller-icon"
    src="../../../../../assets/img/floating-icon.png" alt=">" />
  <img *ngIf="showLineDetails && currentUrl !== '/home'" (click)="showLine()" class="d-md-none float-end position-absolute smaller-icon"
    src="../../../../../assets/img/floating-icon-back.png" alt=">" />
  <div *ngIf="showLineDetails || currentUrl === '/home'"
    class="d-md-none w-100 hcm-roleslist d-flex flex-wrap align-items-center justify-content-md-between p-2 ps-3 pe-3 shadow-sm">
    <div class="col-10 flex-grow-1 hover-expand" [class.multi-line-truncate]="!isHovered"
         (mouseenter)="isHovered = true" (mouseleave)="isHovered = false">
          {{role}} | {{userRoles}}
    </div>
    <a (click)="navigateToEditProfile()" class="hcm-roleslist-edit m-2" *ngIf="currentUrl === '/home'">
      <img src="../../../../assets/img/pencil.svg" alt="Edit" class="p-1">
    </a>
  </div>

  <div
    class="d-none d-md-flex hcm-roleslist w-100 d-flex flex-wrap align-items-center justify-content-md-between ps-2 p-2 shadow-sm">
    <div class="col-10 flex-grow-1">{{role}} | {{userRoles}}</div>
    <a (click)="navigateToEditProfile()" class="hcm-roleslist-edit m-2"  *ngIf="currentUrl === '/home'">
      <img src="../../../../assets/img/pencil.svg" alt="Edit" class="p-1">
    </a>
  </div>
</div>